const makeInitialState = () => {
  return {
    phones: [],
  };
};

export default makeInitialState;
